// extracted by mini-css-extract-plugin
export default {"nicknameForm":"nickname-form_nicknameForm__IZ8yv","inputWrapper":"nickname-form_inputWrapper__a2NHa","buttonWrapper":"nickname-form_buttonWrapper__Dwp7y"};